module.exports = "<div class=\"no_agents_label\">{{noAccountFound}}</div>";